// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2AyVK","author":"Table_author__1BXY8","authorImage":"Table_authorImage__13Hsy","unreadRow":"Table_unreadRow__2kreZ"};